import WrapContent from './WrapContent';

export { WrapContent };
